import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Button, Form, FormGroup, Input, Label } from "reactstrap";
import api from "../../Axios";
import Swal from "sweetalert2";

const UpdateKulamDetails = () => {
  const history = useHistory();
  const { id } = useParams();

  const kulamList = [
    "Beerahavaru",
    "Bodhuvaru",
    "Bomma jallivaru",
    "Boothivaru",
    "Dhasarivaru",
    "Dheiyaluvaru",
    "Dhogaluvaru",
    "Dhommaluvaru",
    "Dhoothaluvaruu",
    "Eeraluvaru",
    "Engiti aaguluvaru",
    "Entaluvaru",
    "Entavaru",
    "Eramavaru",
    "Etthulu Thantavaru",
    "Janavaru",
    "Jallivaru",
    "Jitthaluvaru",
    "Kachchavaru",
    "Kannadivaru",
    "Karavaru",
    "Kejjaluvaru",
    "Kodavaru",
    "Kommuvaru",
    "Kommuluvaru",
    "Kobaluvaru",
    "Koolivaru",
    "Kothaluvaru",
    "Kotangivaru",
    "Kuntamukkavaru",
    "Kuntavaru",
    "Kurukunjaluvaru",
    "Machchaluvaru",
    "Maithulavaru",
    "Mangavaru",
    "Mamidikuntaluvaru",
    "Mudikiluvaru",
    "Nallamullavaru",
    "Nelliyamvaru",
    "Other",
    "Pachchiluvaru",
    "Pallavaru",
    "Pandhivaru",
    "Pantivaru",
    "Paravaru",
    "Parvaivaru",
    "Patamasalavaru",
    "Payidikutthaluvaru",
    "Peguluvaru",
    "Pittavaru",
    "Pannavaru",
    "Puliputthaluvaru",
    "Rama jallivaru",
    "Santhavaru",
    "Sembootthuluvaru",
    "Settiselvaru",
    "Soothaluvaru",
    "Sullivaru",
    "Sutravaru",
    "Vejivaru",
  ];

  const [data, setData] = useState({
    fatherKulam: "",
    motherKulam: "",
    kulaDeivam: "",
    templeLocation: "",
  });

  const inputStyle = {
    border: "1.5px solid #757575",
    borderRadius: "12px",
    boxShadow: "none",
    outline: "none",
    fontWeight: "bold",
    color: "#333",
  };

  const labelStyle = {
    color: "#212121",
    fontWeight: "800",
    marginBottom: "6px",
  };

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      userId: Number(id),
      fatherKulam: data.fatherKulam,
      motherKulam: data.motherKulam,
      kulaDeivam: data.kulaDeivam,
      templeLocation: data.templeLocation,
    };

    api
      .post("/admin/userProfile/kulamDetailsUpdate/", payload)
      .then(() => {
        Swal.fire("Success", "Kulam details updated", "success").then(() => {
          history.goBack();
        });
      })
      .catch(() => {
        Swal.fire("Error", "Failed to update kulam details", "error");
      });
  };

  useEffect(() => {
    api
      .get(`/admin/userProfile/profileView?userId=${id}`)
      .then((res) => {
        const d = res.data && res.data.data ? res.data.data : {};
        const horoscope = d.horoscope || {};
        setData({
          fatherKulam: horoscope.fatherKulam || "",
          motherKulam: horoscope.motherKulam || "",
          kulaDeivam: horoscope.kulaDeivam || "",
          templeLocation: horoscope.templeLocation || "",
        });
      })
      .catch(() => {
        Swal.fire("Error", "Failed to load kulam details", "error");
      });
  }, [id]);

  return (
    <div style={{ background: "#fff", marginTop: "70px" }}>
      <div
        style={{
          color: "#1a237e",
          fontWeight: "900",
          padding: "20px 10px",
        }}
      >
        <h4 style={{ fontSize: "1.8rem" }}>Update Kulam & Kula Deiva Details</h4>
      </div>

      <Form
        onSubmit={handleSubmit}
        style={{ padding: 24, maxWidth: 1200, margin: "0 10px" }}
      >
        <FormGroup>
          <Label style={labelStyle}>Father Kulam</Label>
          <Input
            type="select"
            name="fatherKulam"
            value={data.fatherKulam}
            onChange={handleChange}
            style={inputStyle}
          >
            <option value="">Select Father Kulam</option>
            {kulamList.map((kulam, index) => (
              <option key={index} value={kulam}>
                {kulam}
              </option>
            ))}
          </Input>
        </FormGroup>

        <FormGroup>
          <Label style={labelStyle}>Mother Kulam</Label>
          <Input
            type="select"
            name="motherKulam"
            value={data.motherKulam}
            onChange={handleChange}
            style={inputStyle}
          >
            <option value="">Select Mother Kulam</option>
            {kulamList.map((kulam, index) => (
              <option key={index} value={kulam}>
                {kulam}
              </option>
            ))}
          </Input>
        </FormGroup>

        <FormGroup>
          <Label style={labelStyle}>Kula Deivam</Label>
          <Input
            type="text"
            name="kulaDeivam"
            value={data.kulaDeivam}
            onChange={handleChange}
            placeholder="Enter Kula Deivam name"
            style={inputStyle}
          />
        </FormGroup>

        <FormGroup>
          <Label style={labelStyle}>Temple Location</Label>
          <Input
            type="text"
            name="templeLocation"
            value={data.templeLocation}
            onChange={handleChange}
            placeholder="Enter temple location"
            style={inputStyle}
          />
        </FormGroup>

        <Button
          type="submit"
          style={{
            width: "30%",
            borderRadius: 8,
            backgroundColor: "#000",
            color: "#fff",
            fontWeight: "bold",
            padding: "10px 0",
          }}
        >
          Save & Continue
        </Button>
      </Form>
    </div>
  );
};

export default UpdateKulamDetails;
